<template>
  <div>
    <el-form inline>
      <el-form-item label="手机号">
        <el-input placeholder="多个可以用逗号分割" v-model="searchForm.phones">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(0)" />
        </el-input>
      </el-form-item>
      <el-form-item label="姓名">
        <el-input v-model="searchForm.names" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(1)" />
        </el-input>
      </el-form-item>
      <el-form-item label="工号">
        <el-input v-model="searchForm.staffNos" placeholder="多个可以用逗号分割">
          <div slot="suffix" class="el-icon-circle-plus" style="color: dodgerblue; margin-top: 0.5rem; padding-right: 0.5rem; font-size: 150%" @click="addMore(2)" />
        </el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="search" icon="el-icon-search">查询</el-button>
        <el-button @click="reset" icon="el-icon-refresh-right">重置</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" style="width: 100%; margin-top: 1rem" border
              :header-cell-style="{background:'#eee',color:'black'}"
              @select="selectItem"
              @select-all="selectAll"
              max-height="600"
              ref="tableView"
    >
      <el-table-column v-for="(item, index) in listKeyMap"
                       :key="index"
                       :prop="item.key"
                       :label="item.title"
                       :width="item.width"
                       :fixed="item.flex"
                       v-if="item.type !== 3"
                       :type="item.type === 2?'selection':''"
      >
      </el-table-column>
    </el-table>
    <el-pagination style="margin-top: 1rem"
                   :page-size.sync="pageSize"
                   :total.sync="totalCount"
                   :current-page.sync="curPage"
                   @size-change="search"
                   @current-change="search"
                   :page-sizes="[20, 100, 200, 500, 1000]"
                   layout="total, sizes, prev, pager, next, jumper"
    />
    <el-dialog title="批量操作" :visible.sync="showMultipleEditBox">
      <el-card shadow="never" style="flex-wrap: wrap; justify-content: space-around">
        <el-tag v-for="(tag, index) in accountTags" :key="index" closable style="margin: 0.2rem">
          {{tag}}
        </el-tag>
        <el-input ref="multipleInput" style="margin: 0.2rem; width: 120px" size="small" v-model="multipleEditName" placeholder="新增-回车保存" @keyup.enter.native="change"/>
      </el-card>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="doneAction">确 定</el-button>
        <el-button @click="clearAction">清 除</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {queryEmployee, addUserToGroup, removeUserToGroup} from './employeeApi'

export default {
  name: 'permissionGroupMemberEdit',
  data () {
    return {
      accountTags: [],
      list: [],
      listKeyMap: [],
      searchForm: {
        curPage: 1,
        pageSize: 20,
        phones: '',
        names: '',
        staffNos: ''
      },
      multipleEditName: '',
      multipleEditBoxType: 0, // 0 手机/姓名/邮箱 1工号
      showMultipleEditBox: false,
      showEditEmployee: false,
      editEmployeeTitle: '编辑',
      employeeAddOrEdit: false,
      employeeInfo: {phone: '', email: '', name: '', staffNo: '', remark: ''},
      curPage: 1,
      totalCount: 0,
      totalPage: 0,
      pageSize: 20
    }
  },
  created () {
    this.search()
  },
  props: {
    groupData () {
      return null
    }
  },
  watch: {
    groupData () {
      this.search()
    }
  },
  methods: {
    addMore (type) {
      this.multipleEditBoxType = type
      let tempArray
      if (type === 0) {
        tempArray = this.account.split(',')
      } else if (type === 1) {
        tempArray = this.staffNo.split(',')
      }
      for (let i = tempArray.length - 1; i >= 0; i--) {
        const tempText = tempArray[i].trim()
        if (tempText.length === 0) {
          tempArray.splice(i, 1)
        }
      }
      this.accountTags = tempArray
      this.showMultipleEditBox = true
      setTimeout(() => {
        this.$refs.multipleInput.focus()
      }, 100)
    },
    doneAction () {
      this.showMultipleEditBox = false
      if (this.multipleEditBoxType === 0) {
        this.account = this.accountTags.join(',')
      } else if (this.multipleEditBoxType === 1) {
        this.staffNo = this.accountTags.join(',')
      }
    },
    clearAction () {
      this.accountTags = []
    },
    change () {
      const tempName = this.multipleEditName.trim()
      if (tempName.length === 0) {
        return
      }
      if (this.accountTags.indexOf(tempName) < 0) {
        this.accountTags.push(tempName)
      }
      this.multipleEditName = ''
      this.$refs.multipleInput.focus()
    },
    reset () {
      this.searchForm.names = ''
      this.searchForm.phones = ''
      this.searchForm.staffNos = ''
    },
    search () {
      if (this.groupData == null) {
        return
      }
      this.searchForm.permissionGroupId = this.groupData.groupId
      queryEmployee(this.searchForm).then(rsp => {
        const {code, message, result} = rsp
        if (code === 0) {
          const { pagination, values } = result
          const { list, curPage, pageSize, totalCount, totalPage } = pagination
          this.curPage = curPage
          this.pageSize = pageSize
          this.totalPage = totalPage
          this.totalCount = totalCount
          this.list = list
          this.listKeyMap = values
          setTimeout(() => {
            for (let i = 0; i < list.length; i++) {
              const tempItem = list[i]
              const { groupMember } = tempItem
              if (groupMember === true) {
                this.$refs.tableView.toggleRowSelection(tempItem, true)
              }
            }
          }, 100)
        } else {
          this.$message.error(message)
        }
      })
    },
    selectItem (a, b) {
      const isChecked = a.indexOf(b) >= 0
      const { employeeId } = b
      const data = {}
      data.groupId = this.groupData.groupId
      data.employeeIds = [employeeId]
      const thenRsp = (rsp) => {
        const { code } = rsp
        if (code === 0) {
          let msg = '添加成功'
          if (isChecked === false) {
            msg = '删除成功'
          }
          this.$message.success(msg)
        } else {
          const { message } = rsp
          this.$message.error(message)
          this.search()
        }
      }
      if (isChecked === true) {
        addUserToGroup(data).then(thenRsp).catch(null)
      } else {
        removeUserToGroup(data).then(thenRsp).catch(null)
      }
    },
    selectAll (a) {
      const data = {}
      data.groupId = this.groupData.groupId
      data.employeeIds = []
      for (let i = 0; i < this.list.length; i++) {
        const tempItem = this.list[i]
        const { employeeId } = tempItem
        data.employeeIds.push(employeeId)
      }
      const thenRsp = (rsp) => {
        const { code } = rsp
        if (code === 0) {
          let msg = '添加成功'
          if (a.length > 0) {
            msg = '删除成功'
          }
          this.$message.success(msg)
        } else {
          const { message } = rsp
          this.$message.error(message)
          this.search()
        }
      }
      if (a.length > 0) {
        addUserToGroup(data).then(thenRsp).catch(null)
      } else {
        removeUserToGroup(data).then(thenRsp).catch(null)
      }
    }
  }
}
</script>

 <style scoped>

 </style>



// WEBPACK FOOTER //
// src/components/employee/permissionGroupMemberEdit.vue